import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG } from '@sc/data-access-environment';
import {
  buildApiUrl,
  Configuration,
  Environment,
} from '@sc/data-access-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConfigHttpService {
  private readonly apiUrl: string;
  private readonly allConfigsApiUrl: string;

  constructor(
    private readonly httpClient: HttpClient,
    @Inject(ENV_CONFIG) env: Environment
  ) {
    this.apiUrl = buildApiUrl(env.api, 'config');
    this.allConfigsApiUrl = buildApiUrl(env.api, 'configs');
  }

  fetchConfig(): Observable<Configuration> {
    return this.httpClient.get<Configuration>(`${this.apiUrl}`, {
      headers: { requestName: 'config-http fetchConfig' },
    });
  }

  superAdminGetAllConfigs(configIds?: string[]): Observable<Configuration[]> {
    return this.httpClient
      .post<{ configList: Configuration[] }>(
        `${this.allConfigsApiUrl}`,
        { configIdList: configIds },
        {
          headers: { requestName: 'config-http superAdminGetAllConfigs' },
        }
      )
      .pipe(map((configsResult) => configsResult.configList));
  }
}
